<template>
  <div class="vhp-video-player" :class="rounded ? 'rounded' :''">
        <div class="video-wrap"  @mouseover="videoOver()" @mouseleave="videoLeave()" >
            <video class="video" id="video" @click="togglePlay()"  @timeupdate="timeUpdate()">
                <source :src="source + '#t=' + thumbnail" type="video/mp4"  v-if="source"/>
            </video>
            <div class="video-controls-container" v-if="isControlShow && source">
              <div class="video-title">
                {{title}}
              </div>

              <div class="video-controls">

                  <div class="video-progress" 
                    @mouseover="progressOver = true" 
                    @mouseleave="progressOver = false"
                    @mousemove="onUpProgress($event)"
                    @click="onClickProgress($event)"
                  >
                      <div class="progress-wrap" :class="progressOver ? 'on' : ''" :style="'width:' + progressWidth + '%;'">
                        <div class="thumb"/>
                      </div>
                  </div>

                  <div class="video-button-wrap">
                    <div class="button" :class="playIcon"   @click="togglePlay()">
                        <span/>
                        <span/>
                        <span/>
                        <span/>
                    </div>

                    <div class="sound-wrap">
                      <div class="button sound"  @click="onClickVolume()" :class="volume === 0 ? 'mute' : ''">
                          <img src="@/assets/image/volume-md.svg" height="18"/>
                          <span/>
                      </div>
                      <div class="sound-slide">
                        <div class="slide" 
                          @mouseover="soundOver = true" 
                          @mouseleave="soundOver = false"
                          @mousemove="onUpSound($event)"
                          @click="onClickSound($event)"
                        >
                            <div class="progress-wrap" :class="soundOver ? 'on' : ''" :style="'width:' + volume + '%;'">
                              <div class="thumb"/>
                            </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  

                  <!-- <div class="button stop"   @click="stop()">
                      <span/>
                  </div> -->

                  <span class="video-time-text">
                    <span class="now">{{time.minutes + ':' + time.seconds}}</span> 
                    <span class="divider">|</span> 
                    <span class="max">{{durationTime.minutes + ':' + durationTime.seconds}}</span>
                  </span>


                  <span class="video-utils">
                    <div class="button" @click="fullscreen()">
                      <img v-if="!isFullScreen" height="20" src="@/assets/image/fullscreen.svg" alt="full"/>
                      <img v-else height="20" src="@/assets/image/collapse.svg" alt="collapse"/>
                    </div>
                    <div class="logo-button" @click="openBaseUrl()">
                      <img height="16" src="@/assets/image/logo-a.svg" alt="logo"/>
                    </div>
                  </span>
              </div>

            </div>

            <div class="video-click-effect" :class="clickEffectOn ? 'on':''">
                <div class="button" :class="playEffectIcon">
                    <span/>
                    <span/>
                    <span/>
                    <span/>
                </div>
            </div>

            
        </div>

        <div class="video-overlay" absolute v-if="isInit" @click="start()">
            <div class="video-title">
              {{title}}
            </div>
            <div class="button play"   v-if="source">
                <span/>
                <span/>
                <span/>
                <span/>
            </div>

            <div v-else class="empty">
                비디오 파일이 없습니다.
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        source:{
            type:String,
            default:''
        },
        title:{
          type:String,
          default:''
        },
        thumbnail:{
          type:String,
          default:''
        },
        rounded:{
          type:Boolean,
          default: false
        }
    },
  data: () => ({
    file: null,
    video: null,
    videoControls: null,
    videoWorks: null,

    volume:100,
    volumeCache:100,
    volumeMute:false,

    isInit: true,
    isControlShow: false,
    playIcon: "play",
    playEffectIcon: "pause",

    clickEffectOn: false,

    resultEffectOn: false,

    progressWidth:0,
    progressOver: false,
    progressUp: false,

    soundWidth:0,
    soundOver: false,
    soundUp:false,

    time: {
      minutes: "00",
      seconds: "00",
    },
    durationTime: {
      minutes: "00",
      seconds: "00",
    },

    isShowDetail: true,

    inferenceResult: null,

    requestSequence: 0,
    currentSequence: 0,

    isFullScreen:false,
  }),

  mounted() {
    this.init();
  },

  watch: {
    isInit() {
      if (this.isisInit) {
        this.isControlShow = false;
        this.video.stop();
      } else {
        this.durationTime = this.formatTime(Math.round(this.video.duration));
      }
    },
    clickEffectOn() {
      if (this.clickEffectOn) {
        setTimeout(() => {
          this.clickEffectOn = false;
        }, 500);
      }
    },
    resultEffectOn() {
      if (this.resultEffectOn) {
        setTimeout(() => {
          this.resultEffectOn = false;
        }, 300);
      }
    },
  },

  computed: {},
  methods: {
    clickVideoUploader() {
      this.$refs.videoUploader.$children[0].$el.click();
    },

    init() {
      this.video = document.getElementById("video");
      this.video.controls = false;
      document.addEventListener('keydown', (e) => {
        if (e.which ===32) {
          e.preventDefault()
          this.togglePlay()
        } else if (e.which === 37) {
          if(!this.isInit) {
            e.preventDefault()
            this.video.currentTime -= 10
          }
        } else if (e.which === 39) {
          if(!this.isInit){
            e.preventDefault()
            let interval = this.video.duration > 300 ? 10 : 5
            let leftTime = this.video.duration - this.video.currentTime
            if(leftTime <= interval) {
              this.stop()
            } else {
              this.video.currentTime += interval
            }
          }
          
        }
      })

      this.volume = this.video.volume * 100
    },

    isPaused() {
      return this.video.paused || this.video.ended;
    },

    togglePlay() {
      if (!this.source) {
        this.clickVideoUploader();
        return;
      }
      this.clickEffectOn = true;
      if (this.isPaused()) {
        this.play();
      } else {
        this.pause();
      }
    },

    start() {
      this.video.currentTime = 0;
      this.play()
    },

    play() {
      this.video.play();
      this.isInit = false;
      this.playIcon = "pause";
      this.playEffectIcon = "play";
      this.video.focus()
    },

    pause() {
      this.playIcon = "play";
      this.playEffectIcon = "pause";
      this.video.pause();
    },

    stop() {
      this.isInit = true;
      this.playIcon = "play";
      this.video.currentTime = this.thumbnail;
      this.video.pause();
    },

    fullscreen() {
      if(!this.isFullScreen) {
        const player = document.getElementsByClassName('vhp-video-player')[0]
        player.requestFullscreen()
      } else {
        document.exitFullscreen()
      }

      this.isFullScreen = !this.isFullScreen
      // if (this.video.webkitRequestFullscreen) {
      //   // Need this to support Safari
      //   this.video.webkitRequestFullscreen();
      //   this.video.controls = false;
      // } else {
      //   this.video.requestFullscreen();
      // }
    },

    onClickProgress(e){
      this.video.currentTime = this.video.duration * (e.offsetX / e.target.clientWidth);
      this.progressWidth = (e.offsetX * 100 / e.target.clientWidth)
    },

    onUpProgress(e){
      if((e.buttons | e.button) === 1 ) {
        this.progressUp = true
        this.video.currentTime = this.video.duration * (e.offsetX / e.target.clientWidth);
        this.progressWidth = (e.offsetX * 100 / e.target.clientWidth)
      } else {
        this.progressUp = false
      }
    },

    onClickSound(e){
      this.volume = Math.round(e.offsetX * 100 / e.target.clientWidth);
      this.video.volume = this.volume / 100
    },

    onUpSound(e){
      if((e.buttons | e.button) === 1 ) {
        this.soundUp = true
        this.volume = Math.round(e.offsetX * 100 / e.target.clientWidth);
        this.video.volume = this.volume / 100
      } else {
        this.soundUp = false
      }
    },

    onClickVolume() {
      this.volumeMute = !this.volumeMute

      if(this.volumeMute) {
        this.volumeCache = this.video.volume * 100
        this.volume = 0
      } else {
        this.volume = this.volumeCache
      }
      this.video.volume = this.volume / 100
    },

    timeUpdate() {
      if(this.video.currentTime >= this.video.duration) {
        this.stop()
        return
      }

      this.time = this.formatTime(Math.round(this.video.currentTime));

      this.resultEffectOn = true;

      if (!this.progressUp) {
        this.progressWidth = this.video.currentTime * 100 / this.video.duration
      }
    },

    videoOver() {
      this.isControlShow = true;
    },
    videoLeave() {
      console.log()
      if(this.video.paused)
        this.isControlShow = true;
      else
        this.isControlShow = false
    },

    formatTime(timeInSeconds) {
      if (!timeInSeconds) {
        return {
          minutes: "00",
          seconds: "00",
        };
      }
      const result = new Date(timeInSeconds * 1000).toISOString().substr(11, 8);
      return {
        minutes: result.substr(3, 2),
        seconds: result.substr(6, 2),
      };
    },

    openBaseUrl() {
      window.open("https://www.vazilcompany.com", "_blank");
    },
  },
};
</script>

<style lang="scss" src="./vhpPlayer.scss"></style>